import {Modal} from './modal'
import {Utils} from "./Utils";

export interface VideoPopupConfig {
    window: string;
}

export class VideoPopup extends Modal {
    constructor({window}: VideoPopupConfig) {
        super({window});
    }

    getVideoId() {
        return this.elements.window.getAttribute(`data-video`);
    }

    template() {
        return (`
        <div class="video-button-one__overlay">
            <div class="video-button-one__window">
                <button class="video-button-one__close close-btn"></button>
                <div class="video-button-one__video">
                    <iframe 
                        width="100%" 
                        height="100%" 
                        src="https://www.youtube.com/embed/${this.getVideoId()}?autoplay=1" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                        allowfullscreen
                    ></iframe>
                </div>
            </div>
        </div>`);
    }

    destroy() {
        this.elements.window.innerHTML = ``;
    }

    render() {
        this.elements.window.innerHTML = this.template();
        this.addTriggers(`.video-button-one__close`);
    }

    public toggle(trigger: HTMLElement): void {
        const {window, triggers} = this.elements;
        this.isActive = !this.isActive;
        Utils.toggleClass(window, `is-active`);
        Utils.toggleScroll();

        if (this.isActive) {
            this.render();
            Utils.toggleClass(trigger, `is-triggered`);
        } else {
            this.destroy();
            triggers.forEach(nodes => {
                nodes.forEach(node => Utils.removeClass(node, `is-triggered`));
            });
        }
    }
}